"use client";

import { Point } from "@/lib/types/other";
import React from "react";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import { AirQualityStationType } from "@/db/definitions";
import { getAirStationMarkerIcon } from "../../../../_components/station-map-marker";

type Props = {
  markerLabel: string;
  point: Point;
  type: AirQualityStationType;
};

const AirStationDetailMapView: React.FC<Props> = ({
  markerLabel,
  point,
  type,
}) => {
  return (
    <MapContainer
      center={[point.y, point.x]}
      zoom={9}
      className="h-full w-full rounded-xl z-0"
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker
        alt={markerLabel}
        title={markerLabel}
        icon={getAirStationMarkerIcon(type)}
        position={[point.y, point.x]}
      />
    </MapContainer>
  );
};

export default AirStationDetailMapView;
